'use strict';

let promotionToast = require('../utils/promotionToast');

/**
 * @param {Object|jqXHR|null} data - promotion:error payload or AJAX error object.
 * @returns {string|undefined}
 */
function resolveErrorMessage(data) {
	if (!data) {
		return undefined;
	}

	if (typeof data.errorMessage === 'string' && data.errorMessage.length) {
		return data.errorMessage;
	}

	if (data.responseJSON && typeof data.responseJSON.errorMessage === 'string' && data.responseJSON.errorMessage.length) {
		return data.responseJSON.errorMessage;
	}

	return undefined;
}

function bindCartPromotionToast() {
	$('.promo-code-form').on('submit', function () {
		let couponCode = $('.coupon-code-field').val();

		if (couponCode && String(couponCode).trim()) {
			$('body').data('promotionToastPending', true);
			if (window.lavazzaGtm && window.lavazzaGtm.checkout) {
				window.lavazzaGtm.checkout.setPendingApplyPromoCode(couponCode);
			}
		}
	});

	$('body').on('promotion:success', function () {
		if (!$('body').data('promotionToastPending')) {
			return;
		}

		$('body').removeData('promotionToastPending');
		if (window.lavazzaGtm && window.lavazzaGtm.checkout) {
			window.lavazzaGtm.checkout.trackApplyPromoIfPending();
		}
		promotionToast.show({ error: false });
	});

	$('body').on('promotion:error', function (_e, data) {
		if (!$('body').data('promotionToastPending')) {
			return;
		}

		$('body').removeData('promotionToastPending');
		if (window.lavazzaGtm && window.lavazzaGtm.checkout) {
			window.lavazzaGtm.checkout.clearPendingApplyPromoCode();
		}
		promotionToast.show({
			error: true,
			message: resolveErrorMessage(data),
		});
	});
}

module.exports = function initCartPromotionToast() {
	if ($('[data-promotion-toast]').length || $('.promo-code-form').length) {
		bindCartPromotionToast();
	}
};
